import { render, staticRenderFns } from "./delivery_general_tab.vue?vue&type=template&id=16d18bcc&scoped=true&"
import script from "./delivery_general_tab.vue?vue&type=script&lang=js&"
export * from "./delivery_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d18bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d18bcc')) {
      api.createRecord('16d18bcc', component.options)
    } else {
      api.reload('16d18bcc', component.options)
    }
    module.hot.accept("./delivery_general_tab.vue?vue&type=template&id=16d18bcc&scoped=true&", function () {
      api.rerender('16d18bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/deliveries/location/tabs/delivery_general_tab.vue"
export default component.exports